module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-word-fill-98f738e8.svg";